import { useState } from 'react'

import Shared from '@/shared'

interface CheckItems {
  check: boolean
  text: string
  route: string
}
export interface TicketDetailViewModel {
  texts: object
  states: {
    allChecked: boolean
    disabledChecked: boolean
    checkedItems: CheckItems[]
  }
  setters: object
  handlers: {
    handleNextBtn: () => void
    handleCheckChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void
    handleAllCheckChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  }
}

const useTicketDetailViewModel = (): TicketDetailViewModel => {
  const [allChecked, setAllChecked] = useState(false)
  const setStep = Shared.States.usePurchaseStep((state) => state.setPurchaseStep)

  const [checkedItems, setCheckedItems] = useState([
    { check: false, text: '(필수) 모두의주차장 이용약관', route: process.env.NEXT_PUBLIC_PAGE_POLICY_HOST || '' },
    {
      check: false,
      text: '(필수) 개인정보 처리방침',
      route: `${process.env.NEXT_PUBLIC_PAGE_POLICY_HOST || ''}/privacy`
    },
    {
      check: false,
      text: '(필수) 위치정보 이용약관',
      route: `${process.env.NEXT_PUBLIC_PAGE_POLICY_HOST || ''}/location`
    }
  ])

  const handleNextBtn = () => {
    setStep(1)
  }

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newCheckedItems = [...checkedItems]

    newCheckedItems[index] = {
      ...newCheckedItems[index],
      check: event.target.checked
    }
    if (newCheckedItems.filter((el) => el.check === false)) {
      setAllChecked(false)
    }
    if (newCheckedItems.slice(0, 3).every((item) => item.check === true)) {
      setAllChecked(true)
    }
    setCheckedItems(newCheckedItems)
  }

  const handleAllCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAllChecked(event.target.checked)
    setCheckedItems((prevState) =>
      prevState.map((item) => ({
        ...item,
        check: event.target.checked
      }))
    )
  }
  const disabledChecked = !checkedItems.slice(0, 3).every((item) => item.check === true)

  return {
    texts: {},
    states: {
      allChecked,
      checkedItems,
      disabledChecked
    },
    setters: {},
    handlers: {
      handleNextBtn,
      handleCheckChange,
      handleAllCheckChange
    }
  }
}

export default useTicketDetailViewModel
